import { RestrictionsPage } from '@/modules/guard';

export const Restrictions = () => {
  return <RestrictionsPage />;
};
